import { Router } from '@angular/router';
import { of, Subject, switchMap } from 'rxjs';
import { NavController } from '@ionic/angular';
import { Clipboard } from '@angular/cdk/clipboard';
import { ChangeDetectorRef, Component } from '@angular/core';

import { MobileReputationService, MobileThemeService } from '@sifca-monorepo/clients';
import { LoyaltySettingsReferralType, LoyaltySettingsType, TargetType } from '@sifca-monorepo/widget-generator';

import { reputationPicture } from '../../environments/environment';
import { MobileMarketPlaceService } from '../../services/marketplace.service';

@Component({
  template: '',
})
export class MobileReferralDetailsComponent {
  private unsubscribeAll = new Subject<void>();

  selectedPartner: TargetType;
  loyaltySettings: LoyaltySettingsType;
  reputationPicture = reputationPicture;
  referral: LoyaltySettingsReferralType;
  darkMode$ = this.themeService.darkMode$;
  widgetSettings$ = this.reputationService.widgetSettings$;
  loyaltySettings$ = this.reputationService.loyaltySettings$;

  get referralLimitRate(): number | null {
    return this.loyaltySettings?.referral?.limit?.rate ?? null;
  }

  constructor(
    protected router: Router,
    protected clipboard: Clipboard,
    protected cd: ChangeDetectorRef,
    protected navCtrl: NavController,
    protected themeService: MobileThemeService,
    protected reputationService: MobileReputationService,
    protected marketPlaceService: MobileMarketPlaceService,
  ) {
    const nav = this.router.getCurrentNavigation();
    this.selectedPartner = nav?.extras?.state?.partner;
    this.reputationService
      .findLoyaltySettingsByTargetOrAggregator(this.selectedPartner?.pos?.id)
      .pipe(
        switchMap((res) => {
          this.loyaltySettings = res;
          this.referral = res?.referral;
          return of(res);
        }),
      )
      .subscribe(() => this.cd.markForCheck());
  }

  copyReferralLink(textToCopy: string) {
    this.clipboard.copy(textToCopy);
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
